import './LockerMarkerIcon.css';

interface LockerMarkerIconProps {
  viewBox: number;
  stopOrder: number;
  color: string;
}

const LockerMarkerIcon = ({
  stopOrder,
  viewBox,
  color,
}: LockerMarkerIconProps) => {
  const centerX = viewBox / 2;
  const centerY = viewBox / 2;
  const circleRadius = 10;

  // Superscript icon position (top-right corner)
  const badgeX = centerX + circleRadius * 1.2;
  const badgeY = centerY - circleRadius * 1.2;

  return (
    <svg
      className="locker-svg"
      viewBox={`0 0 ${viewBox} ${viewBox}`}
      width={viewBox}
      height={viewBox}
    >
      <circle
        cx={centerX}
        cy={centerY}
        r={circleRadius}
        fill="white"
        stroke={color}
        strokeWidth={4}
      />
      <text
        x={centerX}
        y={centerY}
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize="10"
        fontWeight="regular"
        fill="black"
      >
        {stopOrder}
      </text>

      <g transform={`translate(${badgeX}, ${badgeY}) scale(1.5)`}>
        <circle
          cx="0"
          cy="0"
          r="5"
          fill="white"
          stroke={color}
          strokeWidth="2"
        />

        <g transform="scale(0.7)">
          <rect
            x="-3"
            y="-3"
            width="6"
            height="6"
            fill="none"
            stroke={color}
            strokeWidth="0.8"
            rx="0.3"
          />
          <line x1="-3" y1="0" x2="3" y2="0" stroke={color} strokeWidth="0.8" />
          <line x1="0" y1="-3" x2="0" y2="3" stroke={color} strokeWidth="0.8" />
          <circle cx="-1.5" cy="-1.5" r="0.5" fill={color} />
          <circle cx="1.5" cy="-1.5" r="0.5" fill={color} />
          <circle cx="-1.5" cy="1.5" r="0.5" fill={color} />
          <circle cx="1.5" cy="1.5" r="0.5" fill={color} />
        </g>
      </g>
    </svg>
  );
};

export default LockerMarkerIcon;
